import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { BsPlusLg } from 'react-icons/bs'
import { HiMinus } from 'react-icons/hi'
import { Link } from 'gatsby'
import CellPhoneIcon from '../../icons/cellphone'
import ChatIcon from '../../icons/chat-icon'
import MailIcon from '../../icons/mail'
import ChatButton from '../buttons/chat-button/ChatButton'
import BannerAd from './BannerAd'
import { MenuData } from './MenuData'
import SubItems from './SubItems'
import TopItem from './TopItem'

const MobileNav = ({ mobileActive }) => {
  const [menuDropdown, setMenuDropdown] = useState(false)

  const [subitemsDropdown, setSubitemsDropdown] = useState(false)

  const triggerMenu = (index) => {
    if (menuDropdown === index) {
      setMenuDropdown(false)
    } else {
      setSubitemsDropdown(false)
      setMenuDropdown(index)
    }
  }

  const banner = MenuData[0].bannerAd

  return (
    <div
      className={mobileActive ? 'mega-mobile-nav active' : 'mega-mobile-nav'}
    >
      <Row className='contact-squares w-100 d-lg-none m-0'>
        <Col className='contact-square'>
          <a href='tel:18009361287'>
            <span className='icon'>
              <CellPhoneIcon />
            </span>
            <p>Call</p>
          </a>
        </Col>

        <Col className='contact-square'>
          <ChatButton>
            <span className='icon'>
              <ChatIcon />
            </span>
            <p>Chat</p>
          </ChatButton>
        </Col>

        <Col className='contact-square'>
          <a href='mailto:info@rubberflooring4u.com'>
            <span className='icon'>
              <MailIcon />
            </span>
            <p>Email</p>
          </a>
        </Col>
      </Row>

      <div className='mega-menu-items d-lg-none'>
        {MenuData.map((item, index) => {
          return (
            <React.Fragment key={item.TopMenuName}>
              {item.type === 'deals' ? (
                <Link
                  to={item.uri}
                  className='top-menu-name d-flex position-relative'
                  onClick={() => triggerMenu(index)}
                >
                  {item.TopMenuName}
                </Link>
              ) : (
                <div  className='top-menu-name-wrapper'>
                  <div
                    className='top-menu-name d-flex position-relative'
                    onClick={() => triggerMenu(index)}
                  >
                    {item.TopMenuName}
                    <span className='icon'>
                      {menuDropdown === index ? <HiMinus /> : <BsPlusLg />}
                    </span>
                  </div>

                  {item.menus.map((menu, idx) => {
                    return (
                      <div
                        key={menu.menuName}
                        className={`item-wrapper ${
                          menuDropdown === index ? 'd-block' : 'd-none'
                        } ${
                          menuDropdown === index && subitemsDropdown === idx
                            ? 'active'
                            : ''
                        }`}
                      >
                        <TopItem
                          mobileActive={mobileActive}
                          index={idx}
                          name={menu.menuName}
                          dropdown={subitemsDropdown}
                          setDropdown={setSubitemsDropdown}
                          type={item.type}
                          uri={menu.uri}
                        />
                        {menuDropdown === index &&
                        subitemsDropdown === idx &&
                        item.type != 'deals' ? (
                          <div className='fade-in'>
                            <SubItems subitems={menu.subitems} />
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    )
                  })}
                </div>
              )}
            </React.Fragment>
          )
        })}
      </div>
      <div className='d-block d-lg-none'>
        <BannerAd banner={banner} currentDropdown={'collection'} />
      </div>
    </div>
  )
}

export default MobileNav
